import { FormControl, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable()
export class PatchAccountsForm {
    name = new FormControl('', [Validators.required]);
    description = new FormControl('');
    sfAccountId = new FormControl('');
}
